
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface TransportationTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  className?: string;
}

const TransportationTabs: React.FC<TransportationTabsProps> = ({
  activeTab,
  onTabChange,
  className
}) => {
  const isMobile = useIsMobile();

  return (
    <TabsList className={cn(
      "h-auto mb-0 bg-muted/50",
      isMobile ? "w-full grid grid-cols-2 gap-1" : "sm:flex-col sm:w-48 w-full",
      className
    )} vertical={!isMobile}>
      <TabsTrigger 
        value="outbound" 
        onClick={() => onTabChange('outbound')}
        data-state={activeTab === 'outbound' ? 'active' : ''}
        vertical={!isMobile}
        className="w-full data-[state=active]:bg-white data-[state=active]:shadow-sm"
      >
        {isMobile ? "Outbound" : "Outbound Journey"}
      </TabsTrigger>
      <TabsTrigger 
        value="return" 
        onClick={() => onTabChange('return')}
        data-state={activeTab === 'return' ? 'active' : ''}
        vertical={!isMobile}
        className="w-full data-[state=active]:bg-white data-[state=active]:shadow-sm"
      >
        {isMobile ? "Return" : "Return Journey"}
      </TabsTrigger>
    </TabsList>
  );
};

export default TransportationTabs;
